import { Group, Stack, Text } from "@mantine/core";
import PoolsListing from "./PoolsListing";
import FolderAdder from "../../lists/ListingWithContent/contacts/FolderAdder";
import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";

const SendersPools = ({ type = "Email" }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(true);
  return (
    <Stack
      pos={"relative"}
      w={"100%"}
      mr={16}
      px={48}
      mt={16}
      h={"calc(100vh - 80px)"}
    >
      <Group mt={16}>
        <Text size="xl" fw={600}>
          {lang.new_senders.my_pools} {type}
        </Text>

        <FolderAdder
          type={type}
          onFinish={() => setLoading(true)}
          isPool={true}
          isButton
        />
      </Group>
      <PoolsListing type={type} loading={loading} setLoading={setLoading} />
    </Stack>
  );
};

export default SendersPools;
